class AnimatedGridSection extends HTMLElement {
  connectedCallback() {
    this.cards = this.querySelectorAll(".animated-card-item");
    if (!this.cards.length) return;

    this.clearAllActive();
    this.initHoverEffect();
    this.loadSwiperScript();

    // Re-check on resize (desktop → mobile)
    window.addEventListener("resize", () => this.tryInitSwiper());
  }

  initHoverEffect() {
    this.cards[0].classList.add("active");

    this.cards.forEach(card => {
      card.addEventListener("mouseenter", () => {
        this.clearAllActive();
        card.classList.add("active");
      });

      card.addEventListener("click", () => {
        this.clearAllActive();
        card.classList.add("active");
      });
    });
  }

  clearAllActive() {
    this.querySelectorAll(".animated-card-item.active")
      .forEach(item => item.classList.remove("active"));
  }

  loadSwiperScript() {
    if (window.Swiper) {
      this.prepareSlides();
      this.tryInitSwiper();
      return;
    }

    if (!document.querySelector('script[data-swiper-loaded]')) {
      const script = document.createElement("script");
      script.src = "https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js";
      script.dataset.swiperLoaded = "true";
      script.onload = () => {
        this.prepareSlides();
        this.tryInitSwiper();
      };
      document.head.appendChild(script);
    }
  }

  // 🔹 ALWAYS clone cards (desktop or mobile)
  prepareSlides() {
    const wrapper = this.querySelector(".animated-card-group-section-mobile .swiper-wrapper");
    if (!wrapper || wrapper.children.length) return;

    this.cards.forEach(card => {
      const slide = document.createElement("div");
      slide.className = "swiper-slide";
      slide.appendChild(card.cloneNode(true));
      wrapper.appendChild(slide);
    });
  }

  // 🔹 ONLY initialize when visible
  tryInitSwiper() {
    if (this.swiper) return;

    const container = this.querySelector(".animated-card-group-section-mobile");
    if (!container || container.offsetParent === null) return;

    this.swiper = new Swiper(container, {
      slidesPerView: 1.3,
      spaceBetween: 12,
      observer: true,
      observeParents: true,
    });
  }
}

customElements.define("animated-grid-section", AnimatedGridSection);
